import React from 'react';

import { Trans, useTranslation } from '@tecma/i18n';
import { useSelector } from 'react-redux';

import { applicationStateSelectors } from 'store/slices/applicationState/selectors';

import currencyFormatter from 'utils/currencyFormatter';

import './quote-spec.scss';

interface QuoteSpecRequiredProps {
  label: string;
  value: string | number | boolean;
}

// Optional Props
interface QuoteSpecOptionalProps {
  subtitle?: string;
  frequency?: string;
  hideNote?: boolean;
}

// Combined required and optional props to build the full prop interface
export interface QuoteSpecProps extends QuoteSpecRequiredProps, QuoteSpecOptionalProps {}

const QuoteSpec: React.FC<QuoteSpecProps> = ({ label, subtitle, value, frequency, hideNote }) => {
  const { t } = useTranslation();
  const area = useSelector(applicationStateSelectors.selectArea);
  const getPriceContext = () => {
    if (frequency) {
      return frequency === 'monthly' ? 'rent' : undefined;
    }
    return area === 'rent' ? area : undefined;
  };
  const getSpecValue = () => {
    if (value === true) {
      return t('quote.included');
    }
    if (typeof value === 'number') {
      return (
        <>
          <Trans
            i18nKey='quote.price'
            values={{
              price: currencyFormatter('EUR', value),
            }}
            context={getPriceContext()}
            components={{ span: <span /> }}
          />
          {!hideNote && !getPriceContext() && <span className='note-number'>1</span>}
        </>
      );
    }
    return value;
  };
  return (
    <div className='quote-spec'>
      <span className='label'>
        {label}
        {subtitle && <span className='subtitle'>{subtitle}</span>}
      </span>
      <span className='value'>{getSpecValue()}</span>
    </div>
  );
};

export default React.memo(QuoteSpec);
